import React from 'react';
import { FieldChangeGrid } from '@pages/admin/audit-log/change-grid';
import {
    getFieldChangeItems,
    getProcessedFieldChangeItems,
    removePropertiesFromObject,
} from '@pages/admin/audit-log/service';
import Constants, { WidgetTypeCode } from '@utils/constants';
import { auditLogsForStudy_OpraQueries_auditLogsForStudy_AuditRecord } from '@queries/generated/audit.generated';

const propArray = ['IsDeleted', 'CfId'];

interface RecordProps {
    WidgetIds?: number[];
    WidgetNames: string;
    DisplayIndex?: number;
    DisplayName?: string;
    IconName?: number;
    TableCode?: number;
    TypeCode?: number;
    FieldName: string;
}

interface ControlsHubConfigWidgetAuditLogGridProps {
    oldRecord: RecordProps;
    newRecord: RecordProps;
    oldItem?: Record<string, unknown>;
    newItem?: Record<string, unknown>;
    record: auditLogsForStudy_OpraQueries_auditLogsForStudy_AuditRecord;
}

const ControlsHubWidgetAuditLogGrid = ({
    oldRecord,
    newRecord,
    oldItem,
    newItem,
    record,
}: ControlsHubConfigWidgetAuditLogGridProps) => {
    const {
        widgets: { IconsList },
        DataSourceLOV,
    } = Constants;

    const refactorRecord = (rec: RecordProps) => {
        // Add empty WidgetIds array to keep arrayOfObjectsV2 happy
        if (!rec.WidgetIds) {
            rec.WidgetIds = [];
        }

        return {
            ...rec,
            DisplayName: rec?.DisplayName,
            IconName: rec?.IconName ? IconsList.find((iconItem) => iconItem.value === rec.IconName)?.key : null,
            TypeCode: rec?.TypeCode ? WidgetTypeCode[rec?.TypeCode] : null,
            TableCode: rec?.TableCode ? DataSourceLOV.find((ds) => ds.value === rec.TableCode)?.key : null,
            FieldName: rec?.FieldName,
            DisplayIndex: rec.DisplayIndex,
            ...removePropertiesFromObject(record, propArray),
        } as Record<string, unknown>;
    };

    const refactoredOldRecord = refactorRecord(oldRecord as RecordProps);
    const refactoredNewRecord = refactorRecord(newRecord as RecordProps);

    const items = getFieldChangeItems(refactoredOldRecord, refactoredNewRecord, null, (field: string) =>
        getProcessedFieldChangeItems({ oldRecord, newRecord, oldItem, newItem, field }),
    );

    return <FieldChangeGrid items={items} />;
};

export default ControlsHubWidgetAuditLogGrid;
